<template>
  <div>
    <div class="row profile-dashboard-wrapper border-bottom white-bg dashboard-header">
      <div class="col-lg-4 col-xl-3">
        <h2>
          Profiles Dashboard
          <span v-if="!loadingPlugins" class="badge badge-primary">{{ upperCase(mode) }}</span>
        </h2>
      </div>
    </div>

    <div class="container-fluid">
      <!-- Profiles Dashboard Charts -->
      <profiles-charts
        v-show="mode === 'pro'"
        id="dashboard-charts"
        :loading="loadingCharts"
        :data="charts"
        v-if="!loadingPlugins"
      />

      <!-- Profiles Dashboard Data Filters -->
      <div class="row">
        <div class="col-md-12">
          <profiles-data-filter
            @filter="$emit('filter', $event)"
            @download="$emit('download', $event)"
            @display-profiles="$emit('display-profiles')"
            @load-more-profiles="$emit('load-more-profiles')"
            @save-query="$emit('save-query', $event)"
            @delete-query="$emit('delete-query', $event)"
            :loading-profiles="loadingProfiles"
            :loading-saved-queries="loadingSavedQueries"
            :loading="loadingFilters"
            :searching="searching"
            :filters="filters"
            :results="results"
            :savedQueries="savedQueries"
            :mode="mode"
            v-if="!loadingPlugins"
          />
        </div>
      </div>

      <!-- Privacy Data List -->
      <privacy-data-list class="privacy-list" :isloading="loadingOptins" />
    </div>
  </div>
</template>

<script>
import { upperCase } from 'lodash';
import ProfilesDataFilter from '@/components/profiles/ProfilesDataFilter';
import ProfilesCharts from '@/components/profiles/ProfilesCharts';
import PrivacyDataList from '@/components/privacy/PrivacyDataList';

export default {
  name: 'ProfileProDashboard',
  components: {
    ProfilesCharts,
    ProfilesDataFilter,
    PrivacyDataList,
  },
  data: () => ({
    displayProfiles: true,
  }),
  methods: {
    upperCase,
  },
  props: {
    loadingFilters: {
      type: Boolean,
      default: false,
    },
    searching: {
      type: Boolean,
      default: false,
    },
    loadingProfiles: {
      type: Boolean,
      default: false,
    },
    loadingSavedQueries: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Object,
      required: true,
    },
    savedQueries: {
      type: Array,
      required: true,
    },
    charts: {
      type: Object,
      required: true,
    },
    results: {
      type: Object,
      required: true,
    },
    loadingCharts: {
      type: Boolean,
      default: false,
    },
    loadingPlugins: {
      type: Boolean,
      default: false,
    },
    loadingOptins: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'lite',
    },
  },
};
</script>

<style scoped>
.dashboard-header {
  margin-bottom: 35px;
}

.badge {
  margin-top: -30px;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?dc336d72